import { Box } from '@chakra-ui/core'
import { SearchableMenu } from 'components/AdminConsole/commonUI/SearchableMenu'
import useLocaleText from 'components/useLocaleText'
import React from 'react'
import { JOBS_ACTION_FREQUENCIES } from '../utils'

interface IFilterByFrequency {
  selectedFrequency: string
  setSelectedFrequency: (id: string) => void
}

export const FilterByFrequency: React.FC<IFilterByFrequency> = ({ selectedFrequency, setSelectedFrequency }) => {
  const admin_select_placeholder = useLocaleText('admin_select_placeholder')

  return (
    <Box w="max-content" minW="200px" maxW="300px">
      <SearchableMenu
        isShowSearch={false}
        items={[{ id: 'all', name: 'all_types', isShowId: false }, ...JOBS_ACTION_FREQUENCIES]}
        selectedId={selectedFrequency}
        isLocalTranslation
        placeholder={admin_select_placeholder}
        onSelect={(item) => {
          setSelectedFrequency(item.id)
        }}
      />
    </Box>
  )
}
